export default {"src":"/_next/static/media/pointerHand.b0c366f0.svg","height":91,"width":76,"blurWidth":0,"blurHeight":0};